import React from 'react';
import { connect } from 'react-redux';
import { addProduct } from './Cart/Actions/CartActions';

import {
   DialogActions,
   DialogContent,
   DialogTitle,
   Dialog
 } from 'material-ui';

class WinterPackage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      car: '', 
      dataimage: [], 
      data2: [], 
      olddata: [], 
      SearchShow: false, 
      ShowBrand: false, 
      loading: false, 
      hooo: '0', 
      currentProductToAdd: '', 
      showImage: false, 
      imageUrl: '' };
  }

  myFunction = (e, gholi) => {
    if ( this.state.hooo === '0') {
      this.setState({ hooo: gholi });
      this.CarSearch(e, gholi);
    } else {
      this.setState({ hooo: '0' });
    }
  }

  winterpackage = (e) => {
    this.setState({ hooo: '0', data: [], SearchShow: false });
  }

  PackageSearch = (e, jafar) => {
    const url = 'https://www.soratwheels.ca/apii/winterpackages.php';
    this.setState({ loading: true });
    fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.setState({ SearchShow: true, loading: false, dataimage: [...json.data.filter(item => item.wp_model === jafar)], olddata: [...json.data.filter(item => item.wp_model === jafar)] });
        });
  }

  CarSearch = (e, gholi) => {
    const url2 = 'https://www.soratwheels.ca/apii/winterpackages.php';
    fetch(url2)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.setState({ data2: [...json.data] });
      });
  }

  addToCartClickedPackage(product) {

   let price = [];
   price = product.wp_price;
   product.name = 'Winter Package' + ' ' + product.wp_make + ' ' + product.wp_model + ' ' + product.wp_id;
   product.image = 'https://panel.sorat.ca/apii/wpimage/winter-package.jpg';
   product.price = [price];
   product.quantity = 1;
   product.type === 'Winter Package';
   product.promo = ['0'];
   product.entity_id = product.wp_id;
   product.sku = product.wp_id;

   this.props.addProduct(product);
 }

  startWinterShopping = (category) => {
   const herowinterDiv = document.getElementById('heroimage');
   if (herowinterDiv) {
     herowinterDiv.style.backgroundImage = "url('path_to_your_image.jpg')";
     herowinterDiv.style.backgroundSize = 'cover';
     herowinterDiv.style.backgroundPosition = 'center';
     herowinterDiv.style.width = '100%';
   }

    if (category === 'Build your own Package') {
        this.setState({ ShowBrand: false, loading: true });
        window.localStorage.setItem('winter wheels', 'false');
        window.sessionStorage.setItem('winter package page', 'yes');
        window.location.replace('/#/Wheels/Vehicle');
      }
      
    this.setState({ ShowBrand: true });
  }

  renderWinterCategory = (imageUrl, category, disabled) => {
    return (

     <div className="categories-block__column">
       <div className="categories-block__column__imageContainer">

         <img src={window.host + imageUrl} style={{ width: '100%', height: '100%' }}className="categories-block__image" />
       </div>
       <div className="categories-block__btn-container_after" />
       <div className="categories-block__btn-container">
         <button disabled={disabled}
           className="categories-block__btn"
           onClick={() => this.startWinterShopping(category)} >
           {category}
         </button>
       </div>
     </div>
    );
  }
 
  renderWinterCategoryPanels = () => {
   return (
      <div className="categories-block__categories-box" style={{ width: '100%' }}>
       <div id="categoryImageAndButtons" className="categories-block__row">
         { this.renderWinterCategory('/statics/img/winterstore.jpg', 'in-store specials', false) }
         {/* { this.renderWinterCategory('/statics/img/winter.jpg', 'Build your own Package', false) } */}
       </div>
     </div>
    );
  }

  handleOpenimage(e, image) {
    this.setState({ showImage: true, imageUrl: "https://panel.sorat.ca/apii/" + image });
  }

  handleCloseDialogImage() {
    this.setState({ showImage: false, imageUrl: '' });
  }

  render() {  
    
     if (this.state.loading) {
      return (
                    <div>
                        {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
                            <img src={'https://www.soratwheels.ca/pub/static/frontend/Soratwheels/ReactJS/statics/img/loading.svg'}/> :
                            <img src={'https://www.soratwheels.ca/pub/static/frontend/Soratwheels/ReactJS/statics/img/loading.gif'}/>}
                    </div>
      );
    } else if (this.state.SearchShow) {
      return (

       <div style={{ background: '#fff', height: 'auto', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '790px' }}>
          <br/>

           {(this.state.hooo === 'Porsche' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/porsche.png'} className="brandList-brandImage" style={{ height: '105px', padding: '10px 10px 10px 10px', width: 'auto' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'TESLA' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/Tesla.png'} className="brandList-brandImage" style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'BMW' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/bmw.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'Mercedes Benz' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/benz.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'VOLVO' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/volvo.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'VW' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/vw.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'LR' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/lr.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}
           {(this.state.hooo === 'AUDI' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', padding: '10px 10px 10px 10px' }}>
              <a onClick={(e) => this.winterpackage(e)}>
              <img src={'https://www.soratwheels.ca/media/car/audi.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
              </a>
           </div>}

          <br/>

           <div>
              How Many Package found:
              <span style={{ color: 'red', fontWeight: '600' }}>( {this.state.dataimage.length} )</span>
           </div>

        {this.state.dataimage.map((item) =>
              <div key={item.wp_id} style={{ textAlign: 'center', padding: '5px 5px 5px 5px' }}>
                    <hr style={{ fontWeight: '600', color: 'red', borderTop: '2px solid #bd1212', marginTop: '12px', marginBottom: '12px', width: '90%' }}/>
                   <span style={{ color: 'black', fontWeight: '600', fontsize: '14px !important' }}>{item.wp_make} {item.wp_model}</span>
                   <br/>
                   <span style={{ color: 'black', fontWeight: '800', fontsize: '16px !important' }}>{item.wp_title }</span>
                   <br/>

                   <div className='winterlist-desktop' style={{ paddingTop: '2%', display: 'inline-table' }}>
                      <tr>
                          <th style={{ textAlign: 'center', width: '65%' }}>
                  <div>

                     <div style={{ float: 'left' }}>
                     <a onClick={(e) => this.handleOpenimage(e, item.wp_image01)}>
                        <img src={"https://panel.sorat.ca/apii/" + item.wp_image01} className='image1' style={{ cursor: 'zoom-in', rotate: '90deg' }}/>
                     </a>
                     </div>

                     <div>
                     <a onClick={(e) => this.handleOpenimage(e, item.wp_image02)}>
                         {item.wp_image02 == 'NULL' || item.wp_image02 == null ? <img src={'https://soratwheels.ca/media/no_img.jpg'}
                      className="image" style={{ width: '75px', height: 'auto' }}/> : <img className='image' style={{ width: '75px', height: 'auto', rotate: '90deg', cursor: 'zoom-in', paddingLeft: '10px' }} src={"https://panel.sorat.ca/apii/" + item.wp_image02} />}
                     </a>

                     <a onClick={(e) => this.handleOpenimage(e, item.wp_image03)}>
                         {item.wp_image03 == 'NULL' || item.wp_image02 == null ? <img src={'https://soratwheels.ca/media/no_img.jpg'}
                      className="image" style={{ width: '75px', height: 'auto' }}/> : <img className='image' style={{ width: '75px', height: 'auto', rotate: '90deg', cursor: 'zoom-in', paddingLeft: '10px' }} src={"https://panel.sorat.ca/apii/" + item.wp_image03} />}
                     </a>

                     <br/>
                     <a onClick={(e) => this.handleOpenimage(e, item.wp_image04)}>
                        {item.wp_image04 == 'NULL' || item.wp_image02 == null ? <img src={'https://soratwheels.ca/media/no_img.jpg'}
                      className="image" style={{ width: '75px', height: 'auto' }}/> : <img className='image' style={{ width: '75px', height: 'auto', rotate: '90deg', cursor: 'zoom-in', paddingLeft: '10px' }} src={"https://panel.sorat.ca/apii/" + item.wp_image04} />}
                     </a>

                     <a onClick={(e) => this.handleOpenimage(e, item.wp_image05)}>
                        {item.wp_image05 == 'NULL' || item.wp_image02 == null ? <img src={'https://soratwheels.ca/media/no_img.jpg'}
                      className="image" style={{ width: '75px', height: 'auto' }}/> : <img className='image' style={{ width: '75px', height: 'auto', rotate: '90deg', cursor: 'zoom-in', paddingLeft: '10px' }} src={"https://panel.sorat.ca/apii/" + item.wp_image05} />}
                     </a>

                  </div>

                     <Dialog open={this.state.showImage} onClose={(e) => this.handleCloseDialogImage(e)}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="dialog-popup-inventiry-title" style={{ padding: '0px'}}>
                        <a className="closebtnmain" onClick={(e) => this.handleCloseDialogImage(e)}>&times;</a>
                        </DialogTitle>
                        <DialogContent id="dialog-popup-inventiry-body" style={{ width: '550px', height: 'auto', overflow: 'hidden'  }}>
                           <img src={this.state.imageUrl} className='image' style={{ width: '550px', height: 'auto', rotate: '90deg' }}/>
                        </DialogContent>
                      </Dialog>

                 </div>
                          </th>
                           <th style={{ textAlign: 'center', color: '#bd1212', width: '35%', verticalAlign: 'Top' }}>
                              <span style={{ fontSize: '28px' }}>{'$' + parseInt(item.wp_price).toFixed(2)}</span><span> + tax</span>
                              <hr style={{ fontWeight: '500', color: 'black', borderTop: '2px solid black', marginTop: '3px', marginBottom: '3px', width: '100%' }}/>
                              <div style={{ textAlign: 'left', width: '100%', fontSize: '14px' }}>
                              <p style={{ marginBottom: '5px', fontSize: '12px', color: 'black', marginTop: '5px', display: 'flex', alignItems: 'center' }}> <img className='image' style={{ width: '35px', height: 'auto' }} src='https://soratwheels.ca/media/winterpackage/w.png' /> {item.wp_wheelsdetail}</p>
                                 <p style={{ marginBottom: '5px', fontSize: '12px', color: 'black', marginTop: '5px', display: 'flex', alignItems: 'center' }}><img className='image' style={{ width: '50px', height: 'auto' }} src='https://soratwheels.ca/media/winterpackage/t.png' /> {item.wp_tiresdetail}</p>
                                 <p style={{ marginBottom: '5px', fontSize: '12px', color: 'black', marginTop: '5px' }}>{item.c_note}</p>
                             </div>
                          </th>
                      </tr>
                      <tr>
                          <td style={{ fontSize: '12px', color: 'black', fontWeight: '600' }}>SKU: {item.wp_id}
                          </td>
                          <td style={{ paddingLeft: '0%' }}>
                             <button className='categories-block__btn addtocart' onClick={(e) => this.addToCartClickedPackage(item)} > ADD TO CART</button>
                          </td>
                      </tr>
                 </div>

                 <div className='winterlist-mobile' style={{ paddingLeft: '5px' }}>
                      <div className="searchBy-contentTires__btnContainer" style={{ paddingTop: '50px' }}>
                          <div>
                             <p style={{ fontSize: '14px' }}>{item.wp_title }</p>
                             <a onClick={(e) => this.handleOpenimage(e, item.wp_image01)}>
                             <img src={"https://panel.sorat.ca/apii/" + item.wp_image01} className='image1' style={{ rotate: '90deg', width: '250px', paddingTop: '30px', paddingBottom: '30px'}}/>
                             </a>
                             <p style={{ fontSize: '14px', color: 'black', fontWeight: '600' }}>SKU: {item.wp_id}</p>
                          </div>

                           <div>
                              <span style={{ fontSize: '24px', color: '#bd1212', fontWeight: '700' }}>{'$' + parseInt(item.wp_price).toFixed(2)}</span><span> + tax</span>
                              <div style={{ textAlign: 'left', width: '100%', fontSize: '16px', color: 'black' }}>
                                 <p style={{ marginBottom: '1px' }}>- {item.wp_wheelsdetail}</p>
                                 <p style={{ marginBottom: '1px' }}>- {item.wp_tiresdetail}</p>
                                 <p style={{ marginBottom: '1px' }}>{item.wp_note}</p>
                             </div>
                          </div>
                      </div>
                      <div>
                          <div>
                              <button className='categories-block__btn addtocart' onClick={(e) => this.addToCartClickedPackage(item)} > ADD TO CART</button>
                          </div>
                      </div>
                 </div>
             </div>
           )}

     </div>
      );
    } else if ( this.state.ShowBrand) {
      return (
         <div style={{ backgroundColor: 'white', maxWidth: '1100px' }}>

         {(this.state.hooo === 'Porsche' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', paddingTop: '2px' }}> <a onClick={(e) => this.myFunction(e, 'Porsche')} >
            <img src={'https://www.soratwheels.ca/media/car/porsche.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
            <div>PORSCHE</div>
          </div>}

          {(this.state.hooo === 'BMW' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'BMW')} >
            <img src={'https://www.soratwheels.ca/media/car/bmw.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
            <div>BMW</div>
          </div>}

          {(this.state.hooo === 'Mercedes Benz' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'Mercedes Benz')} >
            <img src={'https://www.soratwheels.ca/media/car/benz.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
            <div>MERCEDES BENZ</div>
          </div>}

          {(this.state.hooo === 'TESLA' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'TESLA')} >
           <img src={'https://www.soratwheels.ca/media/car/Tesla.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>TESLA</div>
          </div>}

          {(this.state.hooo === 'VOLVO' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'VOLVO')} >
            <img src={'https://www.soratwheels.ca/media/car/volvo.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
            <div>Volvo</div>
          </div>}

          {(this.state.hooo === 'VW' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'VW')} >
           <img src={'https://www.soratwheels.ca/media/car/vw.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>VOLKSWAGEN</div>
          </div>}

          {(this.state.hooo === 'LR' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'LR')} >
           <img src={'https://www.soratwheels.ca/media/car/lr.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>LANDROVER</div>
          </div>}

          {(this.state.hooo === 'AUDI' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'AUDI')} >
           <img src={'https://www.soratwheels.ca/media/car/audi.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>AUDI</div>
          </div>}

          {(this.state.hooo === 'LEXUS' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'LEXUS')} >
           <img src={'https://www.soratwheels.ca/media/car/lexus.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>LEXUS</div>
          </div>}

          {(this.state.hooo === 'TOYOTA' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'TOYOTA')} >
           <img src={'https://www.soratwheels.ca/media/car/toyota.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>TOYOTA</div>
          </div>}

          {(this.state.hooo === 'CHEVROLET' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'CHEVROLET')} >
           <img src={'https://www.soratwheels.ca/media/car/chevrolet.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>CHEVROLET</div>
          </div>}

          {(this.state.hooo === 'FORD' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer' }}> <a onClick={(e) => this.myFunction(e, 'FORD')} >
           <img src={'https://www.soratwheels.ca/media/car/ford.png'} style={{ /*height: '105px',*/ padding: '10px 10px 10px 10px' }}/> </a>
           <div>FORD</div>
          </div>}

          {(this.state.hooo === 'RAM' || this.state.hooo === '0') && <div className='brandList-brandDiv' style={{ cursor: 'pointer', paddingLeft: '5px', paddingRight: '5px' }}> <a onClick={(e) => this.myFunction(e, 'RAM')} >
           <img src={'https://www.soratwheels.ca/media/car/ram.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/> </a>
           <div>RAM</div>
          </div>}

            { this.state.hooo === 'Porsche' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
               { this.state.data2.filter(imake => imake.wp_model === 'Cayenne').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Cayenne')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/cayenne.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Porsche Cayenne</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/cayenne.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                 <p style={{ color: 'Black' }}> Porsche Cayenne</p>
                 </div>}

                 { this.state.data2.filter(imake => imake.wp_model === 'Macan').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Macan')} >
                    <img src={'https://www.soratwheels.ca/media/car/macan.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Porsche Macan</p>
                    </a> : <div>
                    <img src={'https://www.soratwheels.ca/media/car/macan.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> Porsche Macan</p>
                    </div>}

                 { this.state.data2.filter(imake => imake.wp_model === 'Panamera').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Panamera')} >
                    <img src={'https://www.soratwheels.ca/media/car/panamera.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Porsche Panamera</p>
                    </a> : <div>
                    <img src={'https://www.soratwheels.ca/media/car/panamera.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> Porsche Panamera</p>
                    </div>}

                  { this.state.data2.filter(imake => imake.wp_model === 'Taycan').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Taycan')} >
                    <img src={'https://www.soratwheels.ca/media/car/taycan.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Porsche Taycan</p>
                    </a> : <div>
                    <img src={'https://www.soratwheels.ca/media/car/taycan.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> Porsche Taycan</p>
                    </div>}



            </div>}

            { this.state.hooo === 'BMW' && <div className='winter'>
               { this.state.data2.filter(imake => imake.wp_model === 'X7').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'X7')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/x7.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> X7</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/x7.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                 <p style={{ color: 'Black' }}> X7</p>
                 </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'X5 2007-2018').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'X5 2007-2018')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/x5old.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> X5 (2007-2018)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/x5old.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                 <p style={{ color: 'Black' }}> X5 (2007-2018)</p>
                 </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'X5 2019-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'X5 2019-up')} >
                    <img src={'https://www.soratwheels.ca/media/car/x5new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> X5 (2019-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/x5new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> X5 (2019-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'X3, X4 2018-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'X3, X4 2018-up')} >
                    <img src={'https://www.soratwheels.ca/media/car/x3new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> X3, X4 (2018-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/x3new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> X3, X4 (2018-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === '3, 4 Series 2018-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, '3, 4 Series 2018-up')} >
                    <img src={'https://www.soratwheels.ca/media/car/3new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> 3, 4 Series (2018-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/3new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> 3, 4 Series (2018-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === '5 Series 2018-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, '5 Series 2018-up')} >
                    <img src={'https://www.soratwheels.ca/media/car/5new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>5 Series (2018-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/5new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>5 Series (2018-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === '7 Series 2016-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, '7 Series 2016-up')} >
                    <img src={'https://www.soratwheels.ca/media/car/7new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>7 Series (2016-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/7new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>7 Series (2016-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'i4').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'i4')} >
                    <img src={'https://www.soratwheels.ca/media/car/i4.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>i4</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/i4.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>i4</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'iX').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'iX')} >
                    <img src={'https://www.soratwheels.ca/media/car/ix.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>iX</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/ix.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>iX</p>
                    </div>}
            </div>}

            { this.state.hooo === 'Mercedes Benz' && <div className='winter'>

               { this.state.data2.filter(imake => imake.wp_model === 'ML GLE').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'ML GLE')} >
                    <img src={'https://www.soratwheels.ca/media/car/ml.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>ML GLE</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/ml.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>ML GLE</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'GLC').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'GLC')} >
                    <img src={'https://www.soratwheels.ca/media/car/glc.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>GLC</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/glc.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>GLC</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'GLE Coupe 2021-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'GLE Coupe 2021-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/glecoupe.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>GLE Coupe (2021-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/glecoupe.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>GLE Coupe (2021-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'C43 AMG').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'C43 AMG')} >
                    <img src={'https://www.soratwheels.ca/media/car/c43.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>C43 AMG</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/c43.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>C43 AMG</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'C class').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'C class')} >
                    <img src={'https://www.soratwheels.ca/media/car/cclass.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>C class</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/cclass.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>C class</p>
                    </div>}
            </div>}

            { this.state.hooo === 'TESLA' && <div className='winter'>
               { this.state.data2.filter(imake => imake.wp_model === 'Model X').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Model X')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/x.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Model X</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/x.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Model X</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Model S').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Model S')} >
                    <img src={'https://www.soratwheels.ca/media/car/s.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Model S</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/s.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Model S</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Model 3').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Model 3')} >
                    <img src={'https://www.soratwheels.ca/media/car/3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Model 3</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Model 3</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Model Y').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Model Y')} >
                    <img src={'https://www.soratwheels.ca/media/car/y.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Model Y</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/y.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Model Y</p>
                    </div>}

            </div>}

            { this.state.hooo === 'VOLVO' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              { this.state.data2.filter(imake => imake.wp_model === 'XC90').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'XC90')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/90.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>XC90</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/90.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>XC90</p>
                    </div>}

                    { this.state.data2.filter(imake => imake.wp_model === 'XC60').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'XC60')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/60.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>XC60</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/60.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>XC60</p>
                    </div>}

            </div>}

            { this.state.hooo === 'VW' && <div className='winter'>
               { this.state.data2.filter(imake => imake.wp_model === 'Golf Jetta').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Golf Jetta')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/golf.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Golf Jetta</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/golf.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Golf Jetta</p>
                    </div>}

                    { this.state.data2.filter(imake => imake.wp_model === 'Tiguan 2018-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Tiguan 2018-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/vwnew.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Tiguan (2018-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/vwnew.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Tiguan (2018-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Atlas').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Atlas')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/atlas.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Atlas</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/atlas.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Atlas</p>
                    </div>}
            </div>}

            { this.state.hooo === 'LR' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
               { this.state.data2.filter(imake => imake.wp_model === 'Rangerover Evoque').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Rangerover Evoque')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/evo.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Rangerover Evoque</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/evo.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Rangerover Evoque</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Rangerover Sport Fullsize').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Rangerover Sport Fullsize')} >
                    <img src={'https://www.soratwheels.ca/media/car/rover.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Rangerover Sport Fullsize</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/rover.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> Rangerover Sport Fullsize</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Range Rover').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Range Rover')} >
                    <img src={'https://www.soratwheels.ca/media/car/2023_landrover_rangerover.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}> Range Rover (2023-up) </p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/2023_landrover_rangerover.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}> Range Rover (2023-up)</p>
                    </div>}
            </div>}

            { this.state.hooo === 'AUDI' && <div className='winter'>
               { this.state.data2.filter(imake => imake.wp_model === 'Q3').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Q3')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-q3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Q3</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-q3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Q3</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Q5').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Q5')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-q5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Q5</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-q5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Q5</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'Q7 2017-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'Q7 2017-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-q7new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>Q7 (2017-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-q7new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Q7 (2017-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'A3, S3').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'A3, S3')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-a3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>A3, S3</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-a3.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>A3, S3</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'A4, A5').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'A4, A5')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-a5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>A4, A5</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-a5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>A4, A5</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'A7').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'A7')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/audi-a7.png'} style={{ height: '105px', padding: '10px 10px 10px 10px' }}/>
                    <p style={{ color: 'Black' }}>A7</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/audi-a7.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>A7</p>
                    </div>}
            </div>}

            { this.state.hooo === 'LEXUS' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              { this.state.data2.filter(imake => imake.wp_model === 'RX 2024-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'RX 2024-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/rx.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>RX (2024-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/rx.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>RX (2024-up)</p>
                    </div>}

               { this.state.data2.filter(imake => imake.wp_model === 'NX 2023-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'NX 2023-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/nx.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>NX (2023-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/nx.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>NX (2023-up)</p>
                    </div>}
            </div>}

            { this.state.hooo === 'TOYOTA' && <div className='winter' style={{ display: 'flex', flexWrap: 'nowrap' }}>
                { this.state.data2.filter(imake => imake.wp_model === 'TACOMA 2007-2023').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'TACOMA 2007-2023')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/tacoma.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>Tacoma (2007-2023)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/tacoma.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Tacoma (2007-2023)</p>
                    </div>}

                { this.state.data2.filter(imake => imake.wp_model === 'TACOMA 2024-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'TACOMA 2024-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/tacoma25.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>Tacoma (2024-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/tacoma25.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Tacoma (2024-up)</p>
                    </div>}

                    { this.state.data2.filter(imake => imake.wp_model === '4RUNNER').length > 0 ? <a onClick={(e) => this.PackageSearch(e, '4RUNNER')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/4runner.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>4Runner</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/4runner.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>4Runner</p>
                    </div>}

                    { this.state.data2.filter(imake => imake.wp_model === 'TUNDRA 2007-2021').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'TUNDRA 2007-2021')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/tundra.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>Tundra (2007-2021)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/tundra.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Tundra (2007-2021)</p>
                    </div>}

                    { this.state.data2.filter(imake => imake.wp_model === 'TUNDRA 2022-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'TUNDRA 2022-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/tundra24.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>Tundra (2022-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/tundra24.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Tundra (2022-up)</p>
                    </div>}
            </div>}

            { this.state.hooo === 'CHEVROLET' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              { this.state.data2.filter(imake => imake.wp_model === '1500 2019-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, '1500 2019-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/1500new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>Chevrolet 1500 (2019-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/1500new.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>Chevrolet 1500 (2019-up)</p>
                    </div>}
            </div>}

            { this.state.hooo === 'FORD' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              { this.state.data2.filter(imake => imake.wp_model === 'F150 2004-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'F150 2004-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/f150.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>F150 (2004-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/f150.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>F150 (2004-up)</p>
                    </div>}
            </div>}

            { this.state.hooo === 'RAM' && <div className='winter' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
              { this.state.data2.filter(imake => imake.wp_model === 'RAM 1500 2019-up').length > 0 ? <a onClick={(e) => this.PackageSearch(e, 'RAM 1500 2019-up')} style={{ cursor: 'pointer' }}>
                    <img src={'https://www.soratwheels.ca/media/car/1500-5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial' }}/>
                    <p style={{ color: 'Black' }}>RAM 1500 (2019-up)</p>
                 </a> : <div>
                 <img src={'https://www.soratwheels.ca/media/car/1500-5.png'} style={{ height: '105px', padding: '10px 10px 10px 10px', maxWidth: 'initial', filter: 'opacity(0.3)' }}/>
                    <p style={{ color: 'Black' }}>RAM 1500 (2019-up)</p>
                    </div>}
            </div>}
    </div>

      );
    }

    return (
         <div className="breadcrumbbar__categoriesContainer">
           {this.startWinterShopping()}
       </div>
    );
  }
}

const mapStateToProps = state => ({
  cartProducts: state.cart.products,
  newProduct: state.cart.productToAdd,
  productToRemove: state.cart.productToRemove,
  productToChange: state.cart.productToChange,
  cartTotal: state.total.data
});

export default connect(mapStateToProps, { addProduct })(WinterPackage);



// WEBPACK FOOTER //
// ./src/components/winterpackage.js